import { supabase } from "@/integrations/supabase/client";
import { getMergeConfig } from "@/config/mergeConfigRegistry";
import { generateSelectFieldsFromConfig } from "@/utils/mergeConfigUtils";

export const fetchMatchesByIds = async (ids: string[]) => {
	if (ids.length === 0) return [];
	
	// Get the appropriate select fields from the merge configuration
	const mergeConfig = getMergeConfig("matches");
	const selectFields = mergeConfig ? generateSelectFieldsFromConfig(mergeConfig) : "*";
	
	//console.log(`🔍 Fetching matches with fields: ${selectFields}`);
	
	const { data, error } = await supabase
		.from('matches')
		.select(selectFields)
		.in('id', ids);
	
	if (error) {
		console.error('Error fetching matches:', error);
		throw error;
	}
	
	return data || [];
};